module.exports = __webpack_public_path__ + "4fdf2f4e2c3c766ad74abf00ddbe2337.svg";